import React from "react";
import {connect} from "react-redux";
import {replace} from "react-router-redux";
import {Col, Form, FormGroup, FormControl, ControlLabel, Modal, Button} from "react-bootstrap";
import {removePath, getUrlParams} from "../../common/utils";
import {formatMoney, calcTotals, getJoinSelectedItems, getAllItemsRemainingDeliveryDates, getNextDeliveryDate} from "../../common/basket";
import {submitEcheck} from "../../actions/pay/paymentActions";
import {isFetching} from "../../actions/common/fetchingActions";
import {URLs, FetchingTypes} from "../../common/constants";
import styles from "../../css/paymentDetailsForm.less"

class EcheckForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        const params = getUrlParams();

        this.state = {
            firstName: props.memberDetails.firstName || params.firstName,
            lastName: props.memberDetails.lastName || params.lastName,
            isValidBankAccountNo: true,
            isValidBankRoutingNumber: true,
            isValidSsn: true,
            isValidFirstName: true,
            isValidLastName: true,
            today: this.getTodayStr(),
            showBankNumberModal: false,
            showBankRoutingModal: false
        };
    }

    getTodayStr = () => {
        var date = new Date();
        var dateArr = date.toDateString().split(" ");
        var today = dateArr[1] + " " + dateArr[2] +"," + dateArr[3];
        return today;
    };

    checkBankAccount = () => {
        var reg = /^[0-9]{3,17}$/;
        var res = reg.test(this.state.bankAccountNo);
        this.setState({"isValidBankAccountNo": res});
        return res;
    };

    checkBankRoutingNumber = () => {
        var reg = /^[0-9]{9}$/;
        var res = reg.test(this.state.bankRoutingNumber);
        this.setState({"isValidBankRoutingNumber": res});
        return res;
    };

    checkSSN = () => {
        var reg = /^[0-9]{4}$/;
        var res = reg.test(this.state.ssn);
        this.setState({"isValidSsn": res});
        return res;
    };

    checkName = () => {
        var reg = /^[A-Za-z ]+$/;
        var resFirstName = this.state.firstName && reg.test(this.state.firstName);
        var resLastName = this.state.lastName && reg.test(this.state.lastName);
        this.setState({"isValidFirstName": resFirstName});
        this.setState({"isValidLastName": resLastName});
        return resFirstName && resLastName;
    };

    isValidForm = () => {
        var res1 = this.checkBankAccount();
        var res2 = this.checkBankRoutingNumber();
        var res3 = this.checkSSN();
        var res4 = this.checkName();
        return  res1 && res2 && res3 && res4;
    };

    onSubmitClick = () => {
        if(this.isValidForm()){
            var echeckInfo = {
                farmKey: this.props.serverStaticData.farmKey,
                memberKey: this.props.memberDetails.key,
                subscriptionKey: this.props.subscriptionKey,
                postActionKeyString: this.props.postActionKey,
                name: this.state.firstName + " " + this.state.lastName,
                bankRoutingNumber: this.state.bankRoutingNumber,
                bankAccountNo: this.state.bankAccountNo ,
                refNumber: 0,
                ssn: this.state.ssn,
                time: 0
            };
            this.props.submitEcheck(echeckInfo, this.props.serverStaticData.isChargeOnDelivery, this.props.pageContext);
        }
    };

    onBackClick = () => {
      this.props.onBackClick();
    };

    updateValueToState = (event) => {
        var newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState);
    };

    openBankNumberHelp = () => {
      this.setState({showBankNumberModal: true});
    };

    openBankRoutingHelp = () => {
      this.setState({showBankRoutingModal: true});
    };

    onCloseClick = () => {
        this.setState({ showBankNumberModal: false , showBankRoutingModal: false});
    };

    getHelpModals = () => {
        return (
            <div>
                <Modal show={this.state.showBankNumberModal} className="form-modal" onHide={this.onCloseClick} >
                    <Button onClick={this.onCloseClick}><img className="close-icon" src="/site/store/react/src/images/close.svg" /></Button>
                    <Modal.Body><img src="/site/store/images/account-number-help.png" className="gwt-Image" /></Modal.Body>
                </Modal>
                <Modal show={this.state.showBankRoutingModal} className="form-modal" onHide={this.onCloseClick}>
                    <Button onClick={this.onCloseClick}><img className="close-icon" src="/site/store/react/src/images/close.svg" /></Button>
                    <Modal.Body><img src="/site/store/images/routing-number-help.png" className="gwt-Image" /></Modal.Body>
                </Modal>
            </div>
        )
    };

    render() {
        const farmName = this.props.serverStaticData.farmName;
        const amount = this.props.total;
        const farmPhone = this.props.serverStaticData.farmPhone;
        const farmEmail = this.props.serverStaticData.farmEmail;
        var submitLoadingClass = this.props.showLoading? " loading" : "";
        const submitClasses = "submit-order button" +  submitLoadingClass;
        return (
            <div className="form _lr-hide">
                <div className="title">
                    <i className="back-sign-in-arrow hidden-sm hidden-md hidden-lg" onClick={this.onBackClick} disabled={this.props.showLoading}></i>
                    <h1>Electronic Check Payment</h1>
                    <div className="buttons">
                        <Button  bsStyle="primary" className="back button hidden-xs" onClick={this.onBackClick} disabled={this.props.showLoading}>Back</Button>
                        <Button  bsStyle="primary" className={submitClasses + " hidden-xs"} onClick={this.onSubmitClick} disabled={this.props.showLoading}>Submit</Button>
                    </div>
                </div>
                <h5>Please enter your bank account details you use for this payment</h5>
                <div className="border-container">
                    <div className="inner-container">
                        <fieldset disabled={this.props.showLoading} className="form-container container-fluid">
                            <div className="inner-form">
                                <Form horizontal>
                                    <FormGroup validationState={!this.state.isValidFirstName? "error" : null}>
                                        <Col sm={3}>First Name</Col>
                                        <Col sm={3}><FormControl id="firstName" type="text" placeholder="First Name" onChange={this.updateValueToState} value={this.state.firstName}/></Col>
                                        { !this.state.isValidFirstName ?
                                            <Col sm={6}><ControlLabel>Please enter a valid name (Only alphabetic)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={!this.state.isValidLastName? "error" : null}>
                                        <Col sm={3}>Last Name</Col>
                                        <Col sm={3}><FormControl id="lastName" type="text" placeholder="Last Name" onChange={this.updateValueToState} value={this.state.lastName}/></Col>
                                        { !this.state.isValidLastName ?
                                            <Col sm={6}><ControlLabel>Please enter a valid last name (Only alphabetic)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup  validationState={!this.state.isValidBankAccountNo? "error" : null}>
                                        <Col sm={3}>Bank Account Number</Col>
                                        <Col sm={3} className="bank-field">
                                            <FormControl id="bankAccountNo" type="text" onChange={this.updateValueToState} className="_lr-hide"/>
                                            <img onClick={this.openBankNumberHelp} className="help-icon" src="/site/store/react/src/images/echeck_info.svg" />
                                        </Col>
                                        { !this.state.isValidBankAccountNo ?
                                            <Col sm={6}><ControlLabel>Please enter a valid bank account number (only digits)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={!this.state.isValidBankRoutingNumber? "error" : null}>
                                        <Col sm={3}>Bank Routing Number</Col>
                                        <Col sm={3} className="bank-field">
                                            <FormControl id="bankRoutingNumber" type="text" onChange={this.updateValueToState} className="_lr-hide"/>
                                            <img onClick={this.openBankRoutingHelp} className="help-icon" src="/site/store/react/src/images/echeck_info.svg" />
                                        </Col>
                                        { !this.state.isValidBankRoutingNumber ?
                                            <Col sm={6}><ControlLabel>Please enter a valid bank routing number (9 digits)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={!this.state.isValidSsn? "error" : null}>
                                        <Col sm={3}>Last 4 digits of Social Security Number</Col>
                                        <Col sm={3}><FormControl id="ssn" type="text" onChange={this.updateValueToState} className="_lr-hide"/></Col>
                                        { !this.state.isValidSsn ?
                                            <Col sm={6}><ControlLabel>Please enter the last 4 digits of the bank holder's social security number</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                </Form>
                                {amount !== '$0.00' ?
                                    <div className = "description">
                                        <p>I authorize {farmName} to initiate (debit/credit) entries to the above listed bank account in the amount of {amount} on or after {this.state.today}.</p>
                                        <p>If you have questions and/or need to revoke this authorization, please contact us at {farmPhone} or by email {farmEmail}.</p>
                                    </div>
                                    :undefined
                                }
                            </div>
                        </fieldset>
                        <div className="bottom-container">
                            <a href="https://en.wikipedia.org/wiki/Payment_Card_Industry_Data_Security_Standard" target="_blank"><span className = "bottom-title">Storage of your billing information is 100% PCI compliant</span></a>
                            <Button  bsStyle="primary" className={submitClasses + " visible-xs"} onClick={this.onSubmitClick} disabled={this.props.showLoading}>Submit</Button>
                        </div>
                    </div>
                </div>
                {this.getHelpModals()}
            </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    var checkout = state.checkout || {};
    var returnObject = {
        showLoading: isFetching(state, FetchingTypes.SUBMIT),
        serverStaticData: state.staticData,
        subscriptionKey: state.summary.key,
        orderKey: state.orderStatus.orderKey,
        postActionKey: checkout.postActionKey,
        memberDetails: (state.memberDetails || {})
    };
    if(ownProps.pageContext === URLs.JOIN) {
        var signupData = state.signupData;
        var summary = state.summary;
        var pickupSite = summary.pickupSite || {};
        var selectedData = (signupData.selectedData || {});
        var selectedItems = getJoinSelectedItems(signupData.sharesData.shares, signupData.sharesData.options);
        var itemsRemainingDates = getAllItemsRemainingDeliveryDates(selectedItems.items, signupData.sharesData.remainingScheduleDates);
        var nextDeliveryDates = (signupData.pickupSitesData || {}).nextDeliveryDates;
        var schedules = signupData.schedules || {};
        var nextDeliveryDate = getNextDeliveryDate(pickupSite, selectedItems.items, schedules, nextDeliveryDates);
        var totals = calcTotals(signupData.data.isFarmSeasonal, pickupSite, selectedItems.items, selectedData.selectedPaymentPlan,
            selectedData.coupon, itemsRemainingDates, signupData.sharesData.remainingScheduleDates,
            nextDeliveryDate, signupData.isAddSubscription, summary.discount, state.staticData).totals;
        var totalDue = totals.find(function (total) {
            return total.type === "TOTAL_DUE";
        });
        returnObject.total = totalDue.amount;
    } else if(ownProps.pageContext === URLs.PAY) {
        returnObject.total = ownProps.totalToPay === 0?formatMoney(ownProps.amount):formatMoney(ownProps.totalToPay);
    }else {
        returnObject.total = formatMoney((state.orderStatus.totals.editableTotal || {}).fullPrice);
    }
    return returnObject;
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitEcheck: (echeckInfo, isChargeOnDelivery, pageContext) => {
            dispatch(submitEcheck(echeckInfo, isChargeOnDelivery, pageContext));
        },
        onBackClick: () => {
            dispatch(replace(removePath('/echeck')));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(EcheckForm);



// WEBPACK FOOTER //
// ./src/containers/pay/EcheckForm.js